import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  dates: string;
  navlinks: string[];

  constructor() {
    this.dates = "2019-" + new Date().getUTCFullYear();
  }

  ngOnInit() {
  }

}
